import workspace from "../../core/workspace";

export class SQFTResourceController {
  resourceName = null

  constructor(resourceName) {
    this.resourceName = resourceName
  }

  getResources() {
    return workspace[this.resourceName];
  }

  addResource(resource) {
    workspace[this.resourceName].push(resource);

    return workspace[this.resourceName];
  }

  destroyResource(resource) {
    const index = workspace[this.resourceName].indexOf(resource);
    if (index > -1) {
      resource.destroy();
      workspace[this.resourceName].splice(index, 1);
    }

    return workspace[this.resourceName];
  }

  removeResource = (resource) => {
    const index = workspace[this.resourceName].indexOf(resource);
    if (index > -1) {
      workspace[this.resourceName].splice(index, 1);
    }

    return workspace[this.resourceName];
  };

  getResourceById(searchedId) {
    return workspace[this.resourceName].find(resource => resource.id === searchedId);
  }

  removeAllResources() {
    for (let resource of workspace[this.resourceName]) {
      resource.destroy()
    }
    workspace[this.resourceName] = [];
  }

  exportData() {
    const exportedData = [];
    for (let resource of workspace[this.resourceName]) {
      exportedData.push(resource.export ? resource.export() : resource);
    }
    return exportedData
  }

  importData(data) {
    workspace[this.resourceName] = [];
    for (let resource of data) {
      workspace[this.resourceName].push(resource.import ? resource.import() : resource);
    }
  }
}

